export default __webpack_public_path__ + "static/media/icon_google_ua.60ae8ebc.svg";